import { createSelector } from 'reselect';

import { dashboardSelector } from 'modules/v2/store/selectors/dashboard';

export const statesSelector = createSelector(dashboardSelector, (state) => state.states);
